import { Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material";
import purpleStackIcon from "../../assets/Icons/purpleStackIcon.png";

const FullPackage = ({
  updateThisMoveRequest,
  totalCubicFeet,
  moveRequest,
}: any) => {
  const theme = useTheme();

  const getCarrierName = () => {
    let tenantName = "Wemove";
    if (
      process.env.REACT_APP_URL === "https://sold.wemoveai.com" ||
      process.env.REACT_APP_URL === "https://staging.wemoveai.com"
    ) {
      tenantName = "WeMove";
    } else if (
      process.env.REACT_APP_URL === "https://turbotenant.wemoveai.com"
    ) {
      tenantName = "TurboTenant";
    } else if (
      process.env.REACT_APP_URL === "https://rockstarsprocomplete.wemoveai.com"
    ) {
      tenantName = "Rockstar Pro";
    } else if (
      process.env.REACT_APP_URL === "https://elevatedliving.wemoveai.com"
    ) {
      tenantName = "Elevated Living";
    } else if (
      process.env.REACT_APP_URL === "https://harrington-movers.wemoveai.com"
    ) {
      tenantName = "Harrington Movers";
    } else if (
      process.env.REACT_APP_URL === "https://dependable-movers.wemoveai.com"
    ) {
      tenantName = "Dependable Movers";
    } else if (process.env.REACT_APP_URL === "https://jitmoving.wemoveai.com") {
      tenantName = "JIT Moving";
    } else if (
      process.env.REACT_APP_URL === "https://quicknick-moving.wemoveai.com"
    ) {
      tenantName = "Quick Nick Moving";
    } else if (
      process.env.REACT_APP_URL === "https://miraclemoversutah.wemoveai.com"
    ) {
      tenantName = "Miracle Mover Sutah";
    } else if (
      process.env.REACT_APP_URL === "https://conroymoving.wemoveai.com"
    ) {
      tenantName = "Conroy Moving";
    } else if (
      process.env.REACT_APP_URL ===
      "https://majesticmountainmovers.wemoveai.com"
    ) {
      tenantName = "Majestic Mountain Movers";
    } else if (
      process.env.REACT_APP_URL === "https://skitownmoving.wemoveai.com"
    ) {
      tenantName = "Skitown Moving";
    } else if (
      process.env.REACT_APP_URL === "https://centralcoastmoving.wemoveai.com"
    ) {
      tenantName = "Central Coast Moving";
    } else if (
      process.env.REACT_APP_URL === "https://macs-movingandstorage.wemoveai.com"
    ) {
      tenantName = "Macs Moving And Storage";
    } else if (
      process.env.REACT_APP_URL === "https://roundtablemoving.wemoveai.com"
    ) {
      tenantName = "Round Table Moving";
    } else if (
      process.env.REACT_APP_URL === "https://twomenandatruck.wemoveai.com"
    ) {
      tenantName = "Two Men And A Truck";
    }
    return tenantName;
  };
  return (
    <Grid item xs={12} md={5} marginLeft={"auto"} marginRight={"auto"}>
      <Box
        p={2}
        sx={{
          backgroundColor: "#F2F4FF",
          border: "1px solid #EAECF0",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <img src={purpleStackIcon} width={40} height={40} alt="" />

        <Typography
          variant="subtitle2"
          fontWeight={700}
          color={theme.palette.primary.main}
          fontSize={20}
        >
          {getCarrierName() || ""} Package - With Full Packing & Labor
        </Typography>
        <Typography variant="h5" fontWeight={700}>
          $
          {Math.ceil(
            Number(moveRequest?.move_payment) +
              Number(moveRequest?.packing_price)
          )}
        </Typography>
        <Typography variant="subtitle2" color={"#667085"}>
          Based on your move, a full pro pack where everything is boxed and
          packed properly
        </Typography>
      </Box>

      <Stack direction="row" mt={3} spacing={2} justifyContent={"center"}>
        {/* <Button
          onClick={() => {
            updateThisMoveRequest({
              delivery_details: {
                packagaing_required: false,
              },
            });
          }}
          size="medium"
          sx={{
            width: 130,
            height: 50,
            color: "#5859DF",
            backgroundColor: "#F2F4FF",
            fontSize: 12,
            fontWeight: 550,
          }}
        >
          Reject
        </Button> */}

        <Button
          onClick={() => {
            updateThisMoveRequest({
              delivery_details: {
                packagaing_required: true,
                packaging: {
                  packaging_type: "Full Package",
                  dish_boxes: 0,
                  wardrobe_boxes: 0,
                  med_boxes: 0,
                  large_boxes: 0,
                  book_boxes: 0,
                  small_picture_boxes: 0,
                  medium_picture_boxes: 0,
                  large_picture_boxes: 0,
                  extra_large_picture_boxes: 0,
                  mattress_covers: 0,
                  packing_tapes: 0,
                  tv_boxes: 0,
                  packaging_payment: Number(moveRequest.packing_price),
                  custom_packaging_preference: "Boxes-and-Packing",
                },
              },
            });
          }}
          size="medium"
          sx={{
            width: 130,
            height: 50,
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: "#FFFFFF",
            fontSize: 12,
            fontWeight: 550,
          }}
        >
          Save and Proceed
        </Button>
      </Stack>
    </Grid>
  );
};

export default FullPackage;
